import React from "react";
import cs from "classnames";
import IconFont from "@meitu/xdesign-icon-font";
import { TabItem, TabKey } from "@/constants/workbench";
import Image from "next/image";
import styles from "./index.module.css";
import { statTrack } from "@/utils/mtstat";

interface TabsContentProps {
  tabs: TabItem[];
  activeTab: TabKey;
  setActiveTab?: (key: TabKey) => void;
}

const TabsContent = (props: TabsContentProps) => {
  const { tabs, activeTab, setActiveTab } = props;
  return (
    <div className={styles.tabs}>
      {tabs.map((v) => {
        return (
          <div
            key={v.title}
            className={cs(styles.item, {
              [styles.active]: activeTab === v.key,
            })}
            onClick={() => {
              statTrack("tools_click_ppt_home", {
                click_type:
                  v.key === TabKey.importFile
                    ? "upload_file_tab"
                    : v.key === TabKey.inAWord
                    ? "one_sentence_tab"
                    : "text_tab",
              });
              setActiveTab?.(v.key);
            }}
          >
            <IconFont name={v.icon} fontSize={activeTab === v.key ? 18 : 16} />
            <span className={styles.name}>{v.title}</span>
            {v.tag && <Image className={styles.tag} src={v.tag} alt="tag" />}
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(TabsContent);
